import React from 'react';
import { useTranslation } from 'react-i18next';

import HomeWhoItsForSection from '../components/HomePage/sections/HomeWhoItsForSection';
import MarketingPageShell from '../components/marketing/MarketingPageShell';

interface WhoItsForPageProps {
  onNavigate?: (view: string) => void;
}

const WhoItsForPage: React.FC<WhoItsForPageProps> = ({ onNavigate }) => {
  const { t } = useTranslation();

  return (
    <MarketingPageShell
      onNavigate={onNavigate}
      activeView="who-its-for"
      title={t('pages.whoItsFor.seoTitle', 'Who GoGrabJob Is For | Job Seekers & Career Changers')}
      description={t(
        'pages.whoItsFor.seoDescription',
        'Whether you are actively hunting, switching careers, or leveling up — GoGrabJob helps you apply smarter and land more interview calls.',
      )}
      canonical="https://www.gograbjob.com/who-its-for"
    >
      <HomeWhoItsForSection onNavigate={onNavigate} />
    </MarketingPageShell>
  );
};

export default WhoItsForPage;
